import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import type { FaqItem } from '../types/faq';
import { trackEvent } from '../utils/analytics';
interface FaqSectionProps {
  id: string;
  title: string;
  items: FaqItem[];
  size?: 'md' | 'lg';
}
export function FaqSection({
  id,
  title,
  items,
  size = 'md'
}: FaqSectionProps) {
  return <section id={id} aria-labelledby={`${id}-title`} className="scroll-mt-28" data-id="element-61" data-mp="1gjvjj8h09bic">
      <h2 id={`${id}-title`} className={`font-serif font-semibold tracking-tight ${size === 'lg' ? 'text-3xl sm:text-4xl' : 'text-2xl'}`} data-id="element-62" data-mp="24ahf409tp3bg">
        {title}
      </h2>
      <div className="mt-5 divide-y divide-line border-y border-line" data-id="element-63" data-mp="1uibpgx71mxzf">
        {items.map(f => <details key={f.question} className="group py-4" onToggle={e => {
        if (e.currentTarget.open) trackEvent('faq_open', {
          faq_section: id,
          question: f.question
        });
      }} data-id="element-64" data-mp="1zhfynntywvpr">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-semibold [&::-webkit-details-marker]:hidden" data-id="element-65" data-mp="2s0lkac2ntb4k">
              <h3 className="text-base" data-id="element-66" data-mp="10uqbklcrxdc0">{f.question}</h3>
              <ChevronDownIcon className="h-5 w-5 shrink-0 text-muted transition-transform duration-200 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-67" data-mp="1el3jwotkuu1v" />
            </summary>
            <p className="mt-3 max-w-3xl leading-relaxed text-muted" data-id="element-68" data-mp="1oirpyawmvnzc">{f.answer}</p>
          </details>)}
      </div>
    </section>;
}